export default __webpack_public_path__ + "static/media/PRESCRIPTION.6419ba79.png";